<template>
    <DCard
        padding
    >
        <Form
            :visma-settings="props.vismaSettings"
            :errors="props.errors"
            @form-submitted="submitData"
        />
    </DCard>
</template>

<script setup>
import { route } from '~@/Composables/route'

import Form from '~@/Components/Settings/VismaSettings/Form'

const props = defineProps({
    vismaSettings: {
        type: Object,
        default () {
            return {}
        }
    },
    errors: {
        type: Object,
        default () {
            return {}
        }
    }
})

const submitData = (form) => {
    form.post(route('settings.visma-settings.store'))
}
</script>
